const Item = ({path}) => {

    const validation = (link) => {
        const parsed = new URL(link)
        return ['https:', 'http:'].includes(parsed.protocol)
    }

    const handleOpen = () => {
        window.open(validation(path) ? path : '', '_blank')
    }

    return <article onClick={handleOpen} className="item border border-dashed border-slate-500 p-2 w-fit flex items-center justify-between gap-2.5 hover:bg-slate-700 hover:text-white">
            <i className="nes-icon coin is-medium"></i>
        </article>
}

export default Item;